// extracted by mini-css-extract-plugin
export default {"rootLayout":"sWjgdT"};